<template>
  <div class="swipe-tab" :class="classNames">
    <div class="swipe-tab-wrapper" v-if="hasItems">
      <div class="swiper-container swipe-tab-container" ref="container">
        <ul class="swiper-wrapper swipe-tab-list">
          <li
            class="swiper-slide swipe-tab-list-item"
            :class="{ 'is-active': value === item.key, 'is-muted': item.muted , 'disabled': bulkFlag}"
            v-for="item in items"
            :key="item.key"
            @click="[!bulkFlag ? onChange(item.key) : '']"
          >
            {{ item.label }}
          </li>
        </ul>
        <span class="swipe-tab-mask is-left">
          <SwipeTabBlur :color="hideGradientColor" position="left" />
        </span>
        <span class="swipe-tab-mask is-right">
          <SwipeTabBlur :color="hideGradientColor" position="right" />
        </span>
      </div>
      <div class="swipe-tab-button-prev" ref="navPrev"></div>
      <div class="swipe-tab-button-next" ref="navNext"></div>
    </div>
  </div>
</template>

<script>
import Swiper, {Navigation} from 'swiper'
import SwipeTabBlur from '@/components/SwipeTabBlur.vue'

function getCssVar(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name)
}

export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    backgroundColor: {
      type: Boolean,
      required: false,
      default: false
    },
    relaxed: {
      type: Boolean,
      required: false,
      default: false
    },
    sticky: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    showActive: {
      type: Boolean,
      required: false,
      default: false
    },
    bulkFlag: {
      type: Boolean,
      required: false,
      default: false
    },
  },

  components: {
    SwipeTabBlur
  },

  data() {
    return {
      swiper: null,
      leftHidden: false,
      rightHidden: false,
      gradientColor: getCssVar('--wc-color-primary-light')
    }
  },

  computed: {
    classNames() {
      return {
        'bg-primary': this.backgroundColor,
        'is-relaxed': this.relaxed,
        'is-sticky': this.sticky,
        'is-left-hidden': this.leftHidden,
        'is-right-hidden': this.rightHidden
      }
    },
    initialSlide() {
      return this.items.findIndex((item) => item.key === this.value)
    },
    hideGradientColor() {
      // 背景色指定ない場合はデフォルトの背景色に合わせて白を設定
      return this.backgroundColor ? this.gradientColor : '#fff'
    },
    hasItems() {
      return this.items.length > 0
    },
  },

  methods: {
    initCarousel() {
      // swiperのdestroy判定
      // routeの変更でカテゴリを切り替えた時のみ実行する
      if (this.swiper) {
        this.swiper.destroy()
      }

      // ゼロ件であれば初期化しない
      if (!this.hasItems) {
        return false
      }

      this.swiper = new Swiper(this.$refs.container, {
        modules: [Navigation],
        initialSlide: this.initialSlide,
        slidesPerView: 'auto',
        navigation: {
          nextEl: this.$refs.navNext,
          prevEl: this.$refs.navPrev,
          disabledClass: 'swipe-tab-button-hidden'
        },
        init: false
      })

      this.swiper.on('init', this.visibillityCheck)
      this.swiper.init()
      this.swiper.on('transitionEnd', this.visibillityCheck)

      this.swiper.on('touchStart', () => {
        this.leftHidden = true
        this.rightHidden = true
      })
    },
    /**
     * タブ左右の可視判定
     * 続きがある場合は境界をぼかすなどの視覚表現を加えるため
     */
    visibillityCheck() {
      const parentRect = this.swiper.el.getBoundingClientRect()
      const slides = this.swiper.slides

      const firstRect = slides[0].getBoundingClientRect()
      const lastRect = slides[slides.length - 1].getBoundingClientRect()

      this.leftHidden = (firstRect.x < parentRect.x)

      const parentWidth = parentRect.x + parentRect.width
      const maxLeftOffset = parentWidth - lastRect.width

      this.rightHidden = (maxLeftOffset < lastRect.x)
    },
    onChange(key) {
      if (this.loading) {
        return false
      }

      this.$emit('input', key)
      this.$emit('change', key)
    }
  },

  watch: {
    items() {
      this.$nextTick(() => this.initCarousel())
    },
    value(val) {
      if (this.showActive) {
        const index = this.items.findIndex(item => item.key === val)
        this.swiper.slideTo(index)
      }
    }
  }
}
</script>
